import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import styles from '../SearchModal.module.scss'

type SearchFilterChipProps = {
  active: boolean
  disabled: boolean
  label: string
  onClick: () => void
}

export function SearchFilterChip({ active, disabled, label, onClick }: SearchFilterChipProps) {
  return (
    <button
      data-testid={SEARCH_MODAL_TEST_IDS.filterChip}
      aria-pressed={active}
      className={styles.filterChip}
      data-state={active ? 'active' : 'inactive'}
      disabled={disabled}
      type="button"
      onClick={onClick}
    >
      {label}
    </button>
  )
}
